import React, { Component } from 'react';
import { Form, Radio } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { SearchDealers } from '@/components';
import styles from '../_style/index.less';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class ChooseSeller extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeVal: null,
        };
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { roundType, pageState, sellerData, roundStatus } = this.props.session;
        const isShowSeller = (roundType === 1);
        return (<React.Fragment>
        <Form.Item required label={'选择经销商'}>
          <div style={{
            marginLeft: 10,
        }}>
            {(pageState !== 2 && roundStatus === 0) ? getFieldDecorator('roundType', {
            initialValue: roundType,
        })(<Radio.Group onChange={(e) => {
            dispatch.session.SET_STATE({
                roundType: e.target.value,
            });
        }}>
                  <Radio value={0}>全部</Radio>
                  <Radio value={1}>小圈</Radio>
                </Radio.Group>) : (sellerData.length > 0 ? sellerData.map((v) => {
            return v.label;
        }).join('，') : (roundType === 0 ? '全部' : ''))}
          </div>
        </Form.Item>
        {(pageState !== 2 && roundStatus === 0) && isShowSeller && (<div className={styles.seller_choose}><SearchDealers /></div>)}
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(ChooseSeller);
